import { render, staticRenderFns } from "./accountDataPermissionManageList.vue?vue&type=template&id=1063f77a&scoped=true"
import script from "./accountDataPermissionManageList.vue?vue&type=script&lang=js"
export * from "./accountDataPermissionManageList.vue?vue&type=script&lang=js"
import style0 from "./accountDataPermissionManageList.vue?vue&type=style&index=0&id=1063f77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063f77a",
  null
  
)

export default component.exports